import { useContext, createContext, ReactNode } from 'react';

interface PortalContextValue {
  isFromPortal: boolean;
  readOnly: boolean;
  accessToken: string | null;
}

const PortalContext = createContext<PortalContextValue>({
  isFromPortal: false,
  readOnly: false,
  accessToken: null,
});

interface PortalProviderProps {
  children: ReactNode;
  value: PortalContextValue;
}

export const PortalProvider = ({ children, value }: PortalProviderProps) => (
  <PortalContext.Provider value={value}>
    {children}
  </PortalContext.Provider>
);

const usePortalContext = () => {
  const context = useContext(PortalContext);
  return context;
};

export const useReadOnlyMode = () => {
  const { readOnly, isFromPortal } = usePortalContext();
  return isFromPortal && readOnly;
};
